import { CountryService, ResponseError } from '@ynap/api-utils';
import { timeout, delay } from '@ynap/promise-utils';
import { FETCH_COUNTRIES_REQUEST, FETCH_COUNTRIES_SUCCESS, FETCH_COUNTRIES_ERROR } from '../constants/ActionTypes';
import { push } from 'connected-react-router';

function fetchCountriesRequest() {
    return {
        type: FETCH_COUNTRIES_REQUEST,
    };
}

function fetchCountriesSuccess(countries) {
    return {
        type: FETCH_COUNTRIES_SUCCESS,
        payload: countries,
    };
}

function fetchCountriesError() {
    return {
        type: FETCH_COUNTRIES_ERROR,
    };
}

export default function fetchCountries() {
    return (dispatch, getState, fetch) => {
        const { locale, config, router } = getState();
        const { langISO } = locale;
        const { location = {} } = router;
        const { pathname } = location;
        // TODO remove config backwards-compatibility
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        const request = CountryService.getCountries({ baseUrl, brandId, clientId, clientSecret, locale: langISO });

        dispatch(fetchCountriesRequest());

        //todo look at if this is shareable across state packages
        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok, status } = response;

                if (ok) {
                    return response.json().then((json) => dispatch(fetchCountriesSuccess(json)));
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(fetchCountriesError(error));
                throw error;
            });
    };
}
